import { requireRoute } from "@/auth/guard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/pl-discovery")({
  beforeLoad: ({ context }) => requireRoute(context, "/pl-discovery"),
});
